import React from "react";
// import { Link } from "react-router-dom";
import db from "../../db/index.json";
import LabelTag from "../reusebale/label";
import ButtonTag from "../reusebale/button";
import ParagraphTag from "../reusebale/Paragraph";
import MyLoader from "../../component/reusebale/myLoader";
const FormSection = (props) => {
  const { verification } = db;

  return (
    <form className="mt-8">
      <div className="w-full mt-3 flex flex-col lg:flex-row lg:justify-between">
        <div class="w-full lg:w-[60%]">
          <LabelTag name={verification.emailLabel} isStaric={false} />
          <div className="w-full relative">
            <input
              value={props.emailValue}
              disabled
              type="text"
              placeholder="Enter your email.."
              className="w-full mt-1 font-popinsRegular bg-bgColor px-3 py-2 text-sm rounded-lg text-darkColor placeholder:text-zinc-700/50 pr-16"
            />
            <div className="absolute top-[6px] right-[2px]">
              {/* <ButtonTag onSubmit={props.onVerify} name={verification.verify} classes='text-xs px-2 bg-themeColor hover:bg-themeColor/90 text-center text-white' /> */}
            </div>
          </div>
        </div>
        <div class="w-full lg:w-[36%] mt-4 lg:mt-0">
          <LabelTag name={verification.otpLabel} isStaric={false} />
          <div className="w-full relative">
            <input
              onChange={props.onChangeOtp}
              value={props.optValue}
              type="number"
              placeholder="Enter OTP"
              className="w-full mt-1 font-popinsRegular bg-bgColor px-3 py-2 text-sm rounded-lg text-darkColor placeholder:text-zinc-700/50"
            />
            <div className="absolute top-[6px] right-[2px]">
              {props.loader ? (
                <MyLoader />
              ) : (
                <ButtonTag
                  onSubmit={props.onVerifyOtp}
                  name={verification.otpSubmit}
                  classes="text-xs px-2 bg-themeColor hover:bg-themeColor/90 text-center text-white"
                />
              )}
            </div>
          </div>
        </div>
      </div>
      {/* <ButtonTag name={verification.verifyMainBtn} classes='text-base bg-themeColor hover:bg-themeColor/90 mt-5 text-center text-white' /> */}
      <div className="w-full text-center pt-5">
        <ParagraphTag
          content={verification.msgOtp}
          classes="text-[#686868] font-popinsRegular text-sm"
        />
        <ParagraphTag
          onTrigger={props.resendOtpHandler}
          content={verification.resend}
          classes="text-themeColor font-popinsRegular text-sm cursor-pointer"
        />
      </div>
    </form>
  );
};

export default FormSection;
